export default {
    bind(el, binding, vnode) {
        
        const _directions = binding.modifiers;
        const _id = binding.argument;

        if (!_directions || !_id) {
            return;
        }

        const _layoutMan = binding.value;
        const _layoutConfig = _layoutMan.GetSelectedList().find(config => config.ID === _id);
        
        if (!_layoutConfig) {
            return;
        }

        const _root = _layoutConfig.Root;

        let _frameKey = -1;

        let _mousePosition = null;

        const _frameCallback = () => {

            if (_mousePosition) {

                const _positionInfo = _layoutConfig.GetPositionInfo();            

                if (_directions.right) {

                    _layoutConfig.SetPositionInfo({ Columns: _mousePosition.Column + 1 - _positionInfo.Column });

                }

                if (_directions.bottom) {
                    
                    _layoutConfig.SetPositionInfo({ Rows: _mousePosition.Row + 1 - _positionInfo.Row });

                }

                if (_directions.left) {

                    const _newColumn = _mousePosition.Column;
                    const _newColumns = _positionInfo.Column - _newColumn + _positionInfo.Columns;

                    _layoutConfig.SetPositionInfo({ Column: _newColumn, Columns: _newColumns });

                }

                if (_directions.top) {
                    
                    const _newRow = _mousePosition.Row;
                    const _newRows = _positionInfo.Row - _newRow + _positionInfo.Rows;

                    _layoutConfig.SetPositionInfo({ Row: _newRow, Rows: _newRows });

                }

            }
            

            _frameKey = requestAnimationFrame(_frameCallback);

        };


        const _mousemove = e => {

            _mousePosition = _layoutMan.Context.get("MousePosition");

        };

        const _mouseup = e => {

            _layoutMan.AllowDrag();

            cancelAnimationFrame(_frameKey);
            _frameKey = -1;
            _mousePosition = null;

            document.removeEventListener("mousemove", _mousemove);
            document.removeEventListener("mouseup", _mouseup);
            
        };


        el.addEventListener("mousedown", e => {

            _layoutMan.DisallowDrag();

            _frameKey = requestAnimationFrame(_frameCallback);

            document.addEventListener("mousemove", _mousemove);
            document.addEventListener("mouseup", _mouseup);
        });

    }
};